import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['hiddenField', 'option']

  select (e) {
    const selectedId = e.currentTarget.dataset.id
    this.hiddenFieldTarget.value = selectedId

    this.optionTargets.forEach((el) => {
      el.classList.remove('bg-primary-200')
    })

    e.currentTarget.classList.add('bg-primary-200')
  }
}
